// extracted by mini-css-extract-plugin
module.exports = {"body":"passpracetice_body__2uXc5","bodyFail":"passpracetice_bodyFail__2fo5l"};